import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
var columns = 12;

var colWidth = function colWidth(x) {
  return 100 / columns * x;
};

var colWidthBySizes = function colWidthBySizes(size) {
  return function (props) {
    var numCols = props[size];
    if (!numCols) return null;
    return css(["max-width:", "%;flex-basis:", "%;"], colWidth(numCols), colWidth(numCols));
  };
};

var col =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "styles__col",
  componentId: "sc-19wg43m-0"
})(["text-align:inherit;width:100%;box-sizing:border-box;padding:0 ", ";", " ", "{padding:0 ", ";", "}", "{padding:0 ", ";", "}", "{padding:0 ", ";", "}", "{padding:0 ", ";", "}", "{padding:0 ", ";", "}", "{padding:0 ", ";", "}", ""], px2rem(6), colWidthBySizes('xxs'), styles.breakpoint.xs, px2rem(6), colWidthBySizes('xs'), styles.breakpoint.s, px2rem(8), colWidthBySizes('s'), styles.breakpoint.m, px2rem(8), colWidthBySizes('medium'), styles.breakpoint.l, px2rem(12), colWidthBySizes('l'), styles.breakpoint.xl, px2rem(12), colWidthBySizes('xl'), styles.breakpoint.xxl, px2rem(12), colWidthBySizes('xxl'), boxStyles);
export { col };